import { grayButtonStyles } from "@smartsuite/react-ui/lib/components/buttons/Button/Button.constant";
import { IconButton } from "@smartsuite/react-ui/lib/components/buttons/IconButton/IconButton";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import { SidebarAction } from "../types";
import { GrayColors } from "@smartsuite/types";

export interface SidebarSelectionOrderGroupProps {
  onAction: (action: SidebarAction) => void;
}

export const SidebarSelectionOrderGroup: React.FC<
  SidebarSelectionOrderGroupProps
> = ({ onAction }) => {
  return (
    <div className="sidebar-selection-order-group sidebar-selection-config__section__split-column">
      <div className="sidebar-button-group full">
        <Tooltip
          text="Send backwards"
          className="sidebar-button-icon__tooltip"
          placements={["top", "bottom"]}
          padding={2}
          target={
            <IconButton
              backgroundColor={GrayColors["G-1"]}
              backgroundHoverColor={GrayColors["G-1"]}
              name="send-backward"
              size="M"
              ariaLabel="Send backwards"
              className="sidebar-button-icon"
              color={GrayColors["G-0"]}
              hoverColor={GrayColors["G-0"]}
              onClick={() => onAction(SidebarAction.SendBackwards)}
            />
          }
        />
        <Tooltip
          text="Bring forward"
          className="sidebar-button-icon__tooltip"
          placements={["top", "bottom"]}
          padding={2}
          target={
            <IconButton
              backgroundColor={GrayColors["G-1"]}
              backgroundHoverColor={GrayColors["G-1"]}
              className="sidebar-button-icon"
              name="bring-forward"
              size="M"
              ariaLabel="Bring forward"
              onClick={() => onAction(SidebarAction.BringForward)}
            />
          }
        />

        <Tooltip
          text="Send to back"
          className="sidebar-button-icon__tooltip"
          placements={["top", "bottom"]}
          padding={2}
          target={
            <IconButton
              backgroundColor={GrayColors["G-1"]}
              backgroundHoverColor={GrayColors["G-1"]}
              className="sidebar-button-icon"
              name="send-backwards-all"
              size="M"
              ariaLabel="Send to back"
              color={GrayColors["G-0"]}
              hoverColor={GrayColors["G-0"]}
              onClick={() => onAction(SidebarAction.SendToBack)}
            />
          }
        />
        <Tooltip
          text="Bring to front"
          className="sidebar-button-icon__tooltip"
          placements={["top", "bottom"]}
          padding={2}
          target={
            <IconButton
              backgroundColor={GrayColors["G-1"]}
              backgroundHoverColor={GrayColors["G-1"]}
              className="sidebar-button-icon"
              name="bring-forward-all"
              size="M"
              ariaLabel="Bring to front"
              style={grayButtonStyles}
              onClick={() => onAction(SidebarAction.BringToFront)}
            />
          }
        />
      </div>
    </div>
  );
};
